import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useText } from '../../theme/common';
import useStyles from './banner-style';
import hcHand from "../../static/HC-website-polygon.svg";


function Banner() {

  const classes = useStyles();
  const text = useText();
  const elem = useRef(null);

  const theme = useTheme();

  const [hide, setHide] = useState(false);

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <div className={classes.root} ref={elem}>
      <div className={classes.canvasWrap}>
        <div className={classes.overlay}>
          <div className={clsx(classes.decoInner, hide && classes.hide)}>
          </div>
        </div>
      </div>
      <Container fixed>
        <div className={classes.bannerWrap}>
          <Grid container alignItems="center" spacing={6}>
            <Grid item xs={12} md={8}>
              <div className={classes.text}>
                <Typography variant="h4" className={text.title2}>
                  {"Upgrade Your Podcast"}
                </Typography>
                <Typography component="p" className={text.subtitle2}>
                  {'AI Powered Podcast Chapters, Transcripts, and Podcasting 2.0 Features for any podcast!'}
                </Typography>
              </div>
              <div className={classes.btnArea}>
                <Button variant="contained" color="secondary" size="large" fullWidth={isMobile} href='signin/'>
                  {'Login / Signup'}
                </Button>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <figure className={classes.objectArt}>
                <img src={hcHand} alt="hand" />
              </figure>
            </Grid>
          </Grid>
        </div>
      </Container>
      <div className={classes.decoBottom}>
        <svg>
          <use xlinkHref="/images/crypto/deco-banner.svg#main" />
        </svg>
      </div>
    </div>
  );
}

export default Banner;
